import type { SportProfile } from '@/types'

export const rugbyLeague: SportProfile = {
  id: 'rugby-league',
  sport: 'rugby',
  gender: 'coed',
  environment: 'outdoor',
  label: 'Rugby League (13s)',
  emoji: '🏉',
  playersOnField: 13,
  contactLevel: 'full',
  hasShotClock: false,
  periods: { label: 'Half', count: 2, durationMinutes: 40 },
  positions: [
    { key: 'prop',       label: 'Prop',          shortLabel: 'P'                  },
    { key: 'hooker',     label: 'Hooker',         shortLabel: 'HK', maxOnField: 1 },
    { key: 'second_row', label: 'Second Row',     shortLabel: 'SR'                },
    { key: 'loose_fwd',  label: 'Loose Forward',  shortLabel: 'LF', maxOnField: 1 },
    { key: 'halfback',   label: 'Half-back',      shortLabel: 'HB', maxOnField: 1 },
    { key: 'standoff',   label: 'Stand-off',      shortLabel: 'SO', maxOnField: 1 },
    { key: 'centre',     label: 'Centre',         shortLabel: 'CTR'               },
    { key: 'winger',     label: 'Winger',         shortLabel: 'WG'                },
    { key: 'fullback',   label: 'Fullback',       shortLabel: 'FB', maxOnField: 1 },
  ],
  stats: [
    { key: 'try',             label: 'Try',           shortLabel: 'T'   },
    { key: 'conversion',      label: 'Conversion',    shortLabel: 'CON' },
    { key: 'penalty_goal',    label: 'Penalty Goal',  shortLabel: 'PG'  },
    { key: 'drop_goal',       label: 'Drop Goal',     shortLabel: 'DG'  },
    { key: 'assist',          label: 'Try Assist',    shortLabel: 'A'   },
    { key: 'tackle',          label: 'Tackle',        shortLabel: 'TCK' },
    { key: 'run',             label: 'Run',           shortLabel: 'RUN' },
    { key: 'offload',         label: 'Offload',       shortLabel: 'OFL' },
    { key: 'caused_turnover', label: 'Forced Error',  shortLabel: 'FE'  },
    { key: 'turnover',        label: 'Error',         shortLabel: 'ERR' },
    { key: 'yellow_card',     label: 'Sin Bin',       shortLabel: 'SB', statType: 'card' },
    { key: 'red_card',        label: 'Red Card',      shortLabel: 'RC', statType: 'card' },
  ],
}
